<template>
  <div class="media_page">
    <Page title="资质审核" :showBottom="!disabled">
      <template slot="top">
        <alert
          text="商家使用富信或卡片短信功能需要先提供相关资质供官方平台侧审核，审核通过后方可使用富信或卡片短信营销功能。"
        ></alert>
      </template>

      <div class="title">
        <span class="name">资质状态：</span>
        <span
          class="value"
          :style="
            status == 1 || status == 3 ? 'color:#67C23A' : 'color:#FE4D45'
          "
          >{{ statusObj[status] }}</span
        >
        <span v-if="refuseReason && status == -1" class="detail"
          >（请修改后重新提交审核）</span
        >
      </div>
      <div v-if="refuseReason && status == -1" class="refuse">
        拒绝原因：{{ refuseReason }}
      </div>
      <div v-if="status == 3" style="text-align: center">
        <img
          src="@/assets/images/backstage/media-success.png"
          alt="已通过"
          width="260"
          style="margin-top: 60px"
        />
        <div class="other_success_text">
          已在其他isv平台申请通过，可直接使用富信功能
        </div>
      </div>
      <template v-else>
        <el-form
          ref="formRef"
          :model="form"
          :rules="rules"
          label-position="right"
          label-width="175px"
          size="small"
          style="width: 645px; margin-top: 20px"
          :disabled="disabled"
        >
          <el-form-item label="资质名称：" prop="qualificationName">
            <el-input
              v-model="form.qualificationName"
              placeholder="请输入"
              :maxlength="30"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="资质描述：" prop="qualificationDesc">
            <el-input
              v-model="form.qualificationDesc"
              placeholder="请输入"
              type="textarea"
              :maxlength="200"
              show-word-limit
              :autosize="{ minRows: 3, maxRows: 30 }"
            ></el-input>
          </el-form-item>
          <el-form-item label="营业执照：" prop="businessLicense">
            <upload :disabled="disabled" v-model="businessLicenseFile">
              <div slot="custom" class="demo_mouseover" @click.stop="">
                <div class="upload_demo demo_businessLicense">查看示例</div>
                <div class="template_businessLicense">
                  <img
                    :src="templateUrl + 'businessLicense.png'"
                    alt="营业执照模板"
                    class="businessLicense_img"
                  />
                </div>
              </div>
            </upload>
          </el-form-item>
          <el-form-item label="签名&会员授权书：" prop="authorizationSignature">
            <upload :disabled="disabled" v-model="authorizationSignatureFile">
              <div
                slot="custom"
                class="upload_demo"
                @click.stop="stopProp('签名&会员授权书')"
              >
                下载模板
              </div>
            </upload>
          </el-form-item>
          <el-form-item label="信息安全保障责任书：" prop="securityCommitment">
            <upload :disabled="disabled" v-model="securityCommitmentFile">
              <div
                slot="custom"
                class="upload_demo"
                @click.stop="stopProp('信息安全保障责任书')"
              >
                下载模板
              </div>
            </upload>
          </el-form-item>
          <el-form-item label="其它资质：" prop="otherQualification">
            <upload
              :disabled="disabled"
              v-model="otherQualificationFile"
            ></upload>
          </el-form-item>
        </el-form>
        <alert :text="tipText" type="info"></alert>
        <!-- <my-popup
          title="保存模板"
          width="370"
          zIndex="3330"
          :flag="showTemplate"
          @close="showTemplate = false"
        >
          <img
            :src="templateUrl + 'businessLicense.png'"
            alt="营业执照模板"
            class="businessLicense_img"
          />
        </my-popup> -->

        <template slot="bottom">
          <el-button @click="() => handleSave(0)">保存草稿</el-button>
          <el-button @click="() => handleSave(1)" type="primary"
            >提交</el-button
          >
        </template>
      </template>
    </Page>
  </div>
</template>

<script>
import Page from "@/components/common/myPage.vue";
import Alert from "@/components/common/myAlert.vue";
import Upload from "@/components/Form/Upload.vue";
import myPopup from "@/components/myPopupForSms";

import {
  getQualification,
  saveQualification,
} from "@/api/backstage/media_qualification.js";

export default {
  components: {
    Page,
    Alert,
    Upload,
    myPopup,
  },
  data: function () {
    return {
      templateUrl:
        "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/",
      showTemplate: true,
      fileObj: {
        name: "",
        url: "",
      },
      status: 4, // 状态(-1 系统拒绝, 0 待审核, 1 系统通过 3 已在其他平台申请 4 未申请)
      statusObj: {
        "-1": "拒绝",
        0: "待审核",
        1: "通过",
        3: "通过",
        4: "未申请",
      },
      refuseReason: null, // 拒绝原因
      form: {
        qualificationName: "", // 资质名称
        qualificationDesc: "", // 资质描述
        businessLicense: "", // 营业执照链接
        businessLicenseFileName: "", // 营业执照
        authorizationSignature: "", // 签名&会员授权书链接
        authorizationSignatureFileName: "", // 签名&会员授权书
        securityCommitment: "", // 信息安全保障责任书链接
        securityCommitmentFileName: "", // 信息安全保障责任书
        otherQualification: "", // 其它资质链接
        otherQualificationFileName: "", // 其它资质
      },
      rules: {
        qualificationName: [{ required: true, message: "资质名称不能为空" }],
        businessLicense: [{ required: true, message: " ", trigger: "blur" }],
        authorizationSignature: [{ required: true, message: " " }],
        securityCommitment: [{ required: true, message: " " }],
      },
      tipText: [
        {
          text: "1. 关系证明：签名与盖章企业不一致时，还需提供关系证明。关系证明包含：营业执照、商标授权书，官网产品介绍截图；",
        },
        {
          text: "2. 党政机关消息内容授权函：当发送方为党政机关时，需提供“党政机关消息内容授权函”；",
        },
        { text: "3. 多文件，请制作成zip包后进行上传；" },
      ],
    };
  },
  computed: {
    disabled() {
      return this.status !== 4 && this.status !== -1;
    },
    // 营业执照对象
    businessLicenseFile: {
      get: function () {
        return {
          name: this.form.businessLicenseFileName,
          url: this.form.businessLicense,
        };
      },
      set: function (newValue) {
        this.form.businessLicenseFileName = newValue.name;
        this.form.businessLicense = newValue.url;
        this.$refs.formRef.validateField("businessLicense");
      },
    },
    // 签名&会员授权书对象
    authorizationSignatureFile: {
      get: function () {
        return {
          name: this.form.authorizationSignatureFileName,
          url: this.form.authorizationSignature,
        };
      },
      set: function (newValue) {
        this.form.authorizationSignatureFileName = newValue.name;
        this.form.authorizationSignature = newValue.url;
        this.$refs.formRef.validateField("authorizationSignature");
      },
    },
    // 信息安全保障责任书对象
    securityCommitmentFile: {
      get: function () {
        return {
          name: this.form.securityCommitmentFileName,
          url: this.form.securityCommitment,
        };
      },
      set: function (newValue) {
        this.form.securityCommitmentFileName = newValue.name;
        this.form.securityCommitment = newValue.url;
        this.$refs.formRef.validateField("securityCommitment");
      },
    },
    // 其他资质对象
    otherQualificationFile: {
      get: function () {
        return {
          name: this.form.otherQualificationFileName,
          url: this.form.otherQualification,
        };
      },
      set: function (newValue) {
        this.form.otherQualificationFileName = newValue.name;
        this.form.otherQualification = newValue.url;
      },
    },
  },
  created() {
    // 埋点
    this.buriedPoint(1, '富信资质', '后台管理', '富信资质')
  },
  mounted() {
    this.init();
  },
  methods: {
    //
    init() {
      getQualification().then((res) => {
        if (res.code == 1) {
          // this.$message.success("提交成功");
          let { status, refuseReason, ...formObj } = res.data;
          this.status = status;
          // this.status = 3;
          this.refuseReason = refuseReason;
          this.form = formObj;
        }
      });
    },
    // 富信资质保存、提交
    async handleSave(type) {
      if (type == 1) {
        let valid = await this.validate();
        if (!valid) return;
        await this.$confirm("资质提交后不支持修改, 是否确定提交?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          customClass: "media_page_confirm",
        });
      }
      let res = await saveQualification({ ...this.form, type });
      if (res.code == "1") {
        let message = type == 1 ? "提交成功" : "保存草稿成功";
        this.$message.success(message);
        getQualification().then((res) => {
          if (res.code == 1) {
            // this.$message.success("提交成功");
            let { status, refuseReason, ...formObj } = res.data;
            this.status = status;
            // this.status = 3;
            this.refuseReason = refuseReason;
            // this.form = formObj;
          }
        });
      }
    },

    // 校验表单
    validate() {
      return new Promise((resolve, reject) => {
        if (!this.form.qualificationName) {
          this.$message.warning("请填写资质名称");
          resolve(false);
        } else if (!this.form.businessLicense) {
          this.$message.warning("请上传营业执照");
          resolve(false);
        } else if (!this.form.authorizationSignature) {
          this.$message.warning("请上传签名&会员授权书");
          resolve(false);
        } else if (!this.form.securityCommitment) {
          this.$message.warning("请上传信息安全保障责任书");
          resolve(false);
        } else {
          resolve(true);
        }
        // 需求不做此校验，要一个个弹窗展示点击一次提交，只展示一个不符合的校验
        // this.$refs.formRef.validate((valid) => {
        //   if (valid) {
        //     resolve(true);
        //   } else {
        //     resolve(false);
        //   }
        // });
      });
    },

    // 阻止冒泡
    stopProp(url) {
      event.stopPropagation();
      const urlAll = this.templateUrl + url + ".docx";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = urlAll;
      elem.download = url + ".docx";
      document.body.appendChild(elem);
      elem.click();
    },
  },
};
</script>

<style lang="scss" scoped>
.upload_tip {
  margin: 8px 0;
  color: #999999;
  line-height: 12px;
  font-size: 12px;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}
.column {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.demo_mouseover {
  position: relative;
}
.demo_mouseover:hover .template_businessLicense {
  display: block;
  // opacity: 1 !important;
}
.template_businessLicense {
  display: none;
  // opacity: 0;
  position: absolute;
  top: 50%;
  left: 90px;
  // width: 100%;
  // height: 100%;
  // background: rgba(0, 0, 0, 0.5);
  z-index: 101;
  overflow-y: auto;
  transform: translateY(-50%);
  // translate: 0.3s all;
  .businessLicense_img {
    // position: absolute;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
  }
}
// .businessLicense_img {
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
// }
.other_success_text {
  font-size: 14px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
  margin-bottom: 200px;
}
.upload_demo {
  margin-left: 16px;
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #7f85e9;
  cursor: pointer;
}

// 小标题
.title {
  display: flex;
  align-items: center;
  height: 32px;
  background: #fafafa;
  .name {
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
  }
  .value {
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
  }
  .detail {
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #999999;
  }
  &::before {
    content: "";
    width: 4px;
    height: 14px;
    background-color: #fe4d45;
    margin: 0 8px 0 12px;
    border-radius: 3px;
  }
}

//
.refuse {
  display: inline-block;
  padding: 5px 12px;
  font-size: 13px;
  line-height: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #f98a38;
  background: #fffaee;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  margin-top: 12px;
  margin-left: 93px;
  // margin: auto;
}
</style>
<style lang="scss">
/** 单独设置本页的success二次确认弹框 */
.media_page_confirm {
  .el-message-box__content {
    padding: 20px 0 !important;
    .el-message-box__container {
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;
      .el-icon-warning {
        position: relative;
        transform: none;
      }
      .el-message-box__message {
        padding-left: 5px;
      }
    }
  }
}
</style>
